import { ChakraProvider as InnerChakraProvider } from '@frontend/components';

import { useAppSelector } from 'store/hooks';
import { getPreferredDateFormat } from 'store/session/selectors';

export const ChakraProvider = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  const preferredDateFormat = useAppSelector(getPreferredDateFormat);
  return (
    <InnerChakraProvider preferredDateFormat={preferredDateFormat}>
      {children}
    </InnerChakraProvider>
  );
};
